// store.ts
import { googleAuthReducer } from "../Features/Auth/AuthenticationSlice";

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel1 from "redux-persist/es/stateReconciler/autoMergeLevel1";
import storageSession from "redux-persist/lib/storage/session";

const persistConfig = {
  key: "root",
  storage: storageSession,
  stateReconciler: autoMergeLevel1,
};

const rootReducer = combineReducers({
  googleAuth: googleAuthReducer,
});

const persistedReducer = persistReducer<ReturnType<typeof rootReducer>>(
  persistConfig,
  rootReducer
);

const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export const setupStore = (preloadedState?: RootState) => {
  return store;
};

export const createPreloadedState = (
  customState: Partial<RootState>
): RootState => {
  return {
    googleAuth: {
      ...store.getState().googleAuth,
      ...customState.googleAuth,
    },
  };
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = ReturnType<typeof setupStore>;

export default store;
